import React, { Component } from 'react'
import {
  Switch,
  Route,
} from 'react-router-dom'
import { withRouter } from "react-router"

import { AuthLayout } from './../Layout/'
import * as AuthPages from './Pages/'

class Auth extends Component {
  render() {
    return (
      <AuthLayout>
        <Switch>
          <Route exact path="/login" component={AuthPages.Login} />
          <Route exact path="/forgot-password" component={AuthPages.ForgotPassword} />
          <Route path="/reset-password" component={AuthPages.EditPassword} />
          {/* <Route path="/reset-password/:token" component={AuthPages.EditPassword} /> */}
          <Route component={AuthPages.Login} />
        </Switch>
      </AuthLayout>
    )
  }
}

export default withRouter(Auth)


// WEBPACK FOOTER //
// ./src/scenes/Auth/index.js